import React, { FunctionComponent } from 'react'

interface Props {
  fill?: string
  width?: string | number
  height?: string | number
  stroke?: string
}

const ComfortFeatureIcon: FunctionComponent<Props> = ({
  fill = '#040404',
  height = 120,
  width = 120,
  stroke = 'none'
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 256 256" version="1.1">
      <path d="" stroke={stroke} fill={fill} fillRule="evenodd" />
      <path
        d="M 92.247 40.046 C 75.235 43.084, 60.426 52.599, 51.170 66.438 C 45.675 74.653, 42.243 82.829, 41.323 89.890 C 40.557 95.771, 39.396 98, 37.099 98 C 34.042 98, 21.576 104.741, 16.707 109.027 C -7.816 130.613, -4.980 171.074, 22.311 188.985 C 31.449 194.982, 39.132 197.072, 54.500 197.740 L 67.500 198.306 72 202.045 C 93.852 220.201, 126.397 221.372, 149.556 204.836 L 153.612 201.940 157.556 203.664 C 160.289 204.859, 164.278 205.405, 170.548 205.444 C 179.043 205.497, 180.062 205.270, 187.188 201.750 C 194.499 198.139, 195.166 198, 205.253 198 C 218.129 198, 224.643 196.823, 232.736 193.036 C 249.542 185.172, 257.213 169.540, 256.801 144 C 256.665 135.560, 256.659 135.542, 256 141.500 C 255.635 144.800, 255.261 146.559, 255.168 145.410 C 254.929 142.432, 249.598 132.138, 246.126 127.950 C 242.172 123.179, 236.518 119.388, 228.528 116.152 L 221.899 113.467 219.594 106.871 C 214.869 93.349, 204.366 81.641, 191.500 75.554 C 181.902 71.012, 176.091 69.806, 165.332 70.119 L 156.141 70.386 151.391 64.067 C 143.361 53.385, 129.400 44.130, 116.760 41.109 C 109.886 39.466, 98.306 38.964, 92.247 40.046 M 93.182 50.067 C 78.667 52.623, 65.233 62.022, 57.268 75.193 C 53.811 80.910, 50 93.937, 50 100.038 C 50 104.650, 49.116 105.376, 41 107.430 C 28.263 110.653, 19.426 117.939, 13.626 130 C 10.736 136.009, 10.500 137.292, 10.500 147 C 10.500 156.314, 10.804 158.150, 13.196 163.253 C 16.883 171.120, 24.885 179.326, 32.551 183.100 C 39.590 186.565, 47.733 187.918, 61.847 187.967 L 71.193 188 75.847 192.111 C 96.165 210.062, 124.742 211.057, 146.346 194.565 C 151.682 190.493, 153.588 190.239, 158.813 192.905 C 167.470 197.321, 178.428 196.422, 186.232 190.655 L 190.500 187.500 207 187 C 226.397 186.412, 229.835 185.249, 237.716 176.611 C 244.055 169.663, 246.336 163.234, 245.837 153.728 C 245.039 138.546, 235.213 127.169, 220.098 123.928 C 214.111 122.644, 213.370 121.841, 211.485 114.602 C 206.051 93.740, 188.579 79.954, 167.661 80.024 C 163.722 80.037, 158.925 80.397, 157 80.825 C 151.996 81.935, 150.189 81.276, 148.369 77.674 C 138.582 58.312, 114.569 46.300, 93.182 50.067 M 0.365 146.500 C 0.368 152, 0.536 154.122, 0.738 151.216 C 0.941 148.311, 0.939 143.811, 0.734 141.216 C 0.528 138.622, 0.363 141, 0.365 146.500"
        stroke="none"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  )
}

ComfortFeatureIcon.defaultProps = {
  fill: '#040404',
  width: '120',
  height: '120',
  stroke: 'none'
}

export default ComfortFeatureIcon
